<template>
  <div class="property-row">
    <div class="title">
      {{label}}
    </div>
    <div class="value">
      <slot />
    </div>
  </div>
</template>


<style lang="scss" scoped>
.property-row {
  font-size: 0.8rem;
  line-height: 1.1rem;
  .title {
    margin-top: 0.25rem;
    font-weight: bold;
  }
  .value {
    margin-bottom: 0.25rem;
  }
}
</style>


<script>
export default {
  name: 'PopoverPropertyRow',
  props: {
    label: String
  }
}
</script>